import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AlertDialogComponent, NoteDialogComponent } from '../../../dialogs';
import { INote } from '../../pay-categories.type';

/**
 * Handles display of dump card
 */
@Component({
	selector: 'app-notes-card',
	styleUrls: ['./notes-card.component.scss'],
	templateUrl: './notes-card.component.html'
})
export class NotesCardComponent implements OnInit {
	constructor(dialog: MatDialog) {
		this.dialogConfig = new MatDialogConfig();
		this.dialog = dialog;
	}

	@Output() public onNotesChange: EventEmitter<INote[]> = new EventEmitter();
	@Output() public onNotesDelete: EventEmitter<INote[]> = new EventEmitter();
	@Input() public notes: INote[];
	@Input() public payCategoryId: number;
	@Input() public isArchived: boolean;

	public notesColumns: string[] = ['name', 'fieldType', 'pickListItems', 'actions'];
	public dialogConfig: MatDialogConfig;
	public dialog: MatDialog;
	public alertDialogRef: MatDialogRef<AlertDialogComponent>;
	public noteDialogRef: MatDialogRef<NoteDialogComponent>;
	public result: string = '';
	public deletesPayCategoryNote: INote[] = [];

	public ngOnInit(): void {
		if (!this.notes) {
			return;
		}
		this.dialogConfig = new MatDialogConfig();
	}

	public isNeedChange(): void {
		this.onNotesChange.emit(this.notes);
	}

	/**
	 * Note Dialog
	 */
	public openNoteDialog(payCategoryId: number, note: INote, rowIndex: number, isEdit: boolean = false): void {
		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.data = {
			payCategoryId: payCategoryId,
			payCategoryNoteSettingId: note ? note.payCategoryNoteSettingId : 0,
			payCategoryNoteSettingsRecordId: note ? note.payCategoryNoteSettingsRecordId : 0,
			name: note ? note.name : '',
			fieldType: note ? note.fieldType : '',
			pickListItems: note ? note.pickListItems : [],
			isRequired: note ? note.isRequired : true,
			effectiveStart: note ? note.effectiveStart : '',
			createdDate: note ? note.createdDate : '',
			lastModifiedDate: note ? note.lastModifiedDate : '',
			lastModifiedByUserId: note ? note.lastModifiedByUserId : '',
			existingNotes: this.notes,
			noteRowIndex: rowIndex,
			isEdit: isEdit
		};

		if (this.dialog) {
			this.noteDialogRef = this.dialog.open(NoteDialogComponent, this.dialogConfig);
		}
		if (this.noteDialogRef) {
			this.noteDialogRef.beforeClosed().subscribe((result: string) => {
				this.result = result;
			});
			this.noteDialogRef.afterClosed().subscribe((newnote: INote) => {
				if (!newnote) {
					this.noteDialogRef = null;
					return;
				}

				if (newnote.order == null || newnote.order < 0) {
					this.notes = [...this.notes, newnote];
					this.isNeedChange();
				} else {
					newnote.isNeedUpdate = true;
					this.notes[newnote.order] = newnote;
					this.isNeedChange();
				}
				this.noteDialogRef = null;
			});
		}
	}

	/**
	 * deletePayCategoryNote
	 */
	public deletePayCategoryNote(note: INote, index: number): void {
		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.data = {
			modalType: 'deleteNote',
			name: note.name
		};
		if (this.dialog) {
			this.alertDialogRef = this.dialog.open(AlertDialogComponent, this.dialogConfig);
		}
		if (this.alertDialogRef) {
			this.alertDialogRef.beforeClosed().subscribe((result: string) => {
				this.result = result;
			});
			this.alertDialogRef.afterClosed().subscribe((isTrue: boolean) => {
				this.alertDialogRef = null;
				if (isTrue) {
					this.deletesPayCategoryNote.push(this.notes[index]);
					this.notes.splice(index, 1);
					this.notes = [...[], ...this.notes];
					this.onNotesDelete.emit(this.deletesPayCategoryNote);
					this.onNotesChange.emit(this.notes);
				}
			});
		}
	}
}
